import type { PostPurchaseSurveyParamsResponse } from "@/domains/surveys/models/types";

export const createPostPurchaseSurveyParamsDataModel = (
  rawParams: PostPurchaseSurveyParamsResponse,
) => {
  const extractProperty = (property: string) => {
    return rawParams.find((param) => {
      return param[0] === property;
    })?.[1];
  };

  const extractOrderProducts = () => {
    const orderProducts: { sku: string; name: string; imageUrl?: string }[] = [];

    const productNameEntries = rawParams.filter(([key]) => {
      return key.includes("ProductName");
    });

    productNameEntries.forEach(([key]) => {
      const sku = key.replace("ProductName", "");

      const productName = extractProperty(`${sku}ProductName`);
      const productImgUrl = extractProperty(`${sku}ProductImgUrl`);

      if (productName) {
        orderProducts.push({
          sku,
          name: productName,
          imageUrl: productImgUrl,
        });
      }
    });

    return orderProducts;
  };

  return {
    rawParams,
    symptoms: extractProperty("Symptoms"),
    flowProduct: {
      image: extractProperty("EOC128ProductImgUrl"),
      name: extractProperty("EOC128ProductName"),
    },
    orderProducts: extractOrderProducts(),
  };
};
